import { Phone, Clock, Zap, MapPin, Wallet } from "lucide-react";
import { COMPANY, MEDIA } from "@/lib/constants";

const QUICK = [
  { icon: Clock, text: "Atendimento 24h" },
  { icon: Zap, text: "Chegada Rápida" },
  { icon: MapPin, text: "Viagens Brasil" },
];


export const Hero = () => {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-[92vh] md:min-h-screen flex items-center overflow-hidden pt-24 md:pt-28"
    >
      {/* Background image */}
      <div className="absolute inset-0 z-0">
        <img
          src={MEDIA.truck1}
          alt="Guincho Auto Socorro Ventania em Ribeirão Preto"
          className="w-full h-full object-cover object-center"
          loading="eager"
        />
        <div className="absolute inset-0 hero-overlay hidden md:block"></div>
        <div className="absolute inset-0 hero-overlay-mobile md:hidden"></div>
        <div className="absolute inset-0 grid-bg opacity-40"></div>
      </div>

      {/* Red siren top stripe */}
      <div className="absolute top-0 left-0 right-0 h-1 siren-stripe z-10"></div>

      <div className="container-custom relative z-20 w-full">
        <div className="max-w-3xl fade-up">
          <div className="flex items-center gap-2 mb-6">
            <span className="relative flex h-3 w-3">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#d90429] opacity-75"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-[#d90429]"></span>
            </span>
            <span className="overline text-white/80">
              24 Horas — Ribeirão Preto e Região
            </span>
          </div>

          <h1
            data-testid="hero-headline"
            className="font-display uppercase font-bold text-white leading-[0.95] tracking-tight text-5xl sm:text-6xl lg:text-7xl"
          >
            Guincho{" "}
            <span className="text-[#d90429]">24 Horas</span>
            <br />
            em Ribeirão Preto
          </h1>

          {/* Highlight: Guincho Barato e Econômico */}
          <div
            data-testid="hero-highlight-cheap"
            className="mt-6 inline-flex items-center gap-3 bg-gradient-to-r from-[#d90429] to-[#ef233c] px-5 py-3 border-l-4 border-yellow-400 shadow-[0_0_30px_rgba(217,4,41,0.5)]"
          >
            <Wallet className="w-6 h-6 text-yellow-400 shrink-0" />
            <div>
              <div className="font-display uppercase font-bold text-white text-base sm:text-lg leading-none tracking-wider">
                Guincho Barato e Econômico
              </div>
              <div className="text-white/85 text-xs mt-1 uppercase tracking-widest">
                Melhor preço de Ribeirão Preto
              </div>
            </div>
          </div>

          <p className="mt-6 text-lg md:text-xl text-gray-300 max-w-2xl leading-relaxed">
            Remoção rápida e segura para{" "}
            <strong className="text-white">
              carros, motos, camionetes, trailers e carretinhas
            </strong>
            . Atendimento imediato em qualquer hora do dia ou da noite.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4 items-start sm:items-center">
            <a
              href={`tel:${COMPANY.phoneTel}`}
              data-testid="hero-phone-cta"
              className="group inline-flex items-center gap-4 bg-[#d90429] hover:bg-[#ef233c] transition-colors px-7 py-5 pulse-red shadow-[0_0_40px_rgba(217,4,41,0.5)] w-full sm:w-auto"
            >
              <div className="bg-white/15 rounded-full p-3 group-hover:bg-white/25 transition-colors">
                <Phone className="w-7 h-7 text-white" />
              </div>
              <div className="text-left">
                <div className="overline text-white/80 text-[10px]">
                  Ligue Agora · 24h
                </div>
                <div className="font-display uppercase font-bold text-white text-2xl md:text-3xl leading-none tracking-tight mt-1">
                  {COMPANY.phoneDisplay}
                </div>
              </div>
            </a>
          </div>

          <div className="mt-12 grid grid-cols-3 gap-4 md:gap-8 max-w-xl">
            {QUICK.map((q, i) => {
              const Icon = q.icon;
              return (
                <div
                  key={i}
                  className="flex flex-col items-start gap-2 border-l-2 border-[#d90429] pl-3 md:pl-4"
                >
                  <Icon className="w-5 h-5 text-[#d90429]" />
                  <span className="font-display uppercase text-white text-xs md:text-sm tracking-wider">
                    {q.text}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Bottom scroll hint */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 hidden md:flex flex-col items-center gap-2 text-white/50">
        <span className="overline text-[10px] text-white/50">Role</span>
        <div className="w-px h-8 bg-white/30"></div>
      </div>
    </section>
  );
};
